import React, { useEffect, useState } from "react";
import { Card, Empty, Flex, Input, Typography } from "antd";
import { HistoryOutlined } from "@ant-design/icons";
import { HistorySection } from "@/components/history/HistorySection";

const { Text } = Typography;

/**
 * El Historial del producto del seller (xcons-docs#611): quién lo asoció, con qué producto del
 * catálogo y desde dónde —a mano o con la sugerencia, con su %—, quién lo desasoció o le cambió
 * el factor. Es lo que respalda dejar asociar en masa cualquier sugerencia elegida.
 *
 * La misma tarjeta que el Historial del Catálogo, Presupuestos y Pedidos. **Sin notas**, como el
 * Catálogo: una nota se graba con un store, y el producto de un seller no tiene ninguno.
 */
export const HistorialDelAsociador: React.FC<{
  producto?: any;
  /** Cambiarlo vuelve a pedir la línea de tiempo (después de un cambio, sin salir). */
  recarga?: number;
}> = ({ producto, recarga = 0 }) => {
  const [busqueda, setBusqueda] = useState("");
  const [q, setQ] = useState("");

  useEffect(() => {
    const t = setTimeout(() => setQ(busqueda.trim()), 350);
    return () => clearTimeout(t);
  }, [busqueda]);

  const entityId = producto?.productId;

  return (
    <Card
      className="history-card order-history-card"
      styles={{
        header: { height: 40, minHeight: 40, padding: "0 16px" },
        body: { padding: 0, overflow: "hidden", display: "flex", flexDirection: "column" },
      }}
      title={
        <Flex align="center" gap={24} style={{ width: "100%" }}>
          <Flex gap={4} align="center" style={{ flexShrink: 0 }}>
            <HistoryOutlined style={{ fontSize: 16 }} />
            <Text style={{ fontSize: 14, fontWeight: 600 }}>Historial</Text>
          </Flex>
          <Flex flex={1} gap={16} align="center">
            <Input.Search
              size="small"
              allowClear
              placeholder="Buscar en el historial..."
              value={busqueda}
              onChange={(e) => setBusqueda(e.target.value)}
              style={{ flex: 1 }}
            />
          </Flex>
        </Flex>
      }
    >
      <div style={{ padding: 12 }}>
        {entityId == null ? (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Sin registros" />
        ) : (
          <HistorySection
            key={`linked_product:${entityId}:${recarga}`}
            module="linked_product"
            entityId={entityId}
            notes={false}
            externalQ={q}
          />
        )}
      </div>
    </Card>
  );
};
